import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { ContractType } from '@/routes/_staff/marketplace/-types/product';
const OrderBy = {
  PRODUCT_NAME: 'PRODUCT_NAME'
} as const;
export const SearchSchema = z.object({
  orderDirection: z.nativeEnum(OrderDirection).optional().default(OrderDirection.ASC),
  orderBy: z.nativeEnum(OrderBy).optional(),
  freeText: z.string().optional(),
  contractMethodIn: z.array(z.nativeEnum(ContractType)).optional(),
  pageSize: z.number().int().positive().default(10),
  pageIndex: z.number().int().min(0).default(0),
  priceRangeMin: z.string().optional(),
  priceRangeMax: z.string().optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;